@if (sidenavLoading()) {
  <div class="sidenav-loading">
    <div class="lds-dual-ring"></div>
  </div>
} @else {
  <div>
    <sidenav-title
      [titleTemplate]="titleTemplate"
      customClass="strict-height"
      [isRemoveEnabled]="isResourcesTimeline()"
      (removeClick)="removeProjectFromTimeline()"
    />

    <ng-template #titleTemplate>
      <div class="title cursor-pointer" (click)="showProjectDetails()">
        <h2><span class="pii">{{ project.mainContactFullName }}</span> | <span class="pii">{{ project.fullAddress }}</span></h2>
        <span><span class="pii">{{ project.nameAndProjectID }}</span></span>
      </div>
    </ng-template>

    <div class="project-timeline">
      <ul class="project-timeline__tabs note-type-v2 mb-4">
        <li
          *ngFor="let tab of tabs"
          class="px-3 py-2 cursor-pointer"
          [class.active]="tab.isActive"
          (click)="this.setTabActive(tab)"
          [innerHTML]="tab.name | translate"
        ></li>
      </ul>

      <div class="scroll-container" [ngClass]="{ 'scroll-container--w-footer': isFormDirty$ | async }">
        <ng-container [ngSwitch]="selectedTabType">
          <app-projects-timeline-range
            *ngSwitchCase="'range'"
            [project]="project"
            [timelineData]="{
              timelineAction: timelineAction(),
              timelineId: sideData?.data?.timelineId,
              calculateStageDates: sideData?.data?.calculateStageDates,
              forceCommentRange: sideData?.data?.forceCommentRange,
              isForecast: sideData?.data?.isForecast,
              entryId: sideData?.data?.entryId,
              plannedTermStart: sideData?.data?.plannedTermStart,
              plannedTermEnd: sideData?.data?.plannedTermEnd
            }"
            [disabledRanges]="sideData?.data?.disabledRanges"
          />
          <app-projects-timeline-pause
            *ngSwitchCase="'pause'"
            [project]="project"
            [forceComment]="sideData?.data?.forceCommentPause"
          />
          <app-projects-timeline-stages
            *ngSwitchCase="'stage'"
            [project]="project"
            [activeElement]="activeElement()"
            (onTabChange)="onTabChange($event)"
          />
        </ng-container>
      </div>
    </div>

    <div *ngIf="isFormDirty$ | async" class="sticky-footer">
      <ng-container *ngFor="let button of footerButtons">
        <app-button
          (onClick)="button.action()"
          [loading]="loading() && button.loading"
          [disabled]="loading()"
          [config]="{
            size: ButtonSize.LARGE,
            type: button.type,
            text: button.text | translate
          }"
        />
      </ng-container>
    </div>
  </div>
}
